import { uuid } from 'vue3-uuid';
import { baseUrl } from '~/utils/http/request';
import { useResponseHandler } from '~/utils/http/handler';
import { encryptRSA } from '~/utils/crypto'
export const useRequests = () => {
    const { handler } = useResponseHandler();
    const { postForm } = useApis();
    return {
        // 用户修改自己密码
        modifyPwd: async (p: {
            oldPassword: string | null;
            newPassword: string | null;
            confirmPassword: string | null;
        }) => {
            const encryptedOldPassword = encryptRSA(p.oldPassword || '');
            const encryptedNewPassword = encryptRSA(p.newPassword || '');
            const encryptedConfirmPassword = encryptRSA(p.confirmPassword || '');
            const encryptedData = {
                oldPassword: encryptedOldPassword,
                newPassword: encryptedNewPassword,
                confirmPassword: encryptedConfirmPassword,
            };

            const res = await postForm<
                {
                    oldPassword: string | null;
                    newPassword: string | null;
                    confirmPassword: string | null;
                },
                boolean
            >(`${baseUrl}/auth/user/modifyPwd`, encryptedData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'x-sequence-no': uuid.v4().replace(/\-/g, ''),
                    },
                },
            );
            return await handler(res, {
                successMessage: true,
            });
        },
    };
};
